export default __webpack_public_path__ + "static/media/product-1.d5239745.jpg";